export const Do = [{
    "id":"1",
    "name":"Plain Dosa",
    "price" :"Price :₹30",
    "image": process.env.PUBLIC_URL + "/assests/Dosa/5p.png",
    "description": "The quintessential South Indian classic—thin, ultra-crispy fermented rice-and-lentil crepe cooked to a perfect golden brown."
},
{
    "id":"2",
    "name":"Karam Dosa",
    "price" :"Price :₹30",
    "image": process.env.PUBLIC_URL + "/assests/Dosa/4k.png",
    "description": "Classic golden dosa coated with a fiery, traditional spicy red chili-garlic chutney paste and roasted with pure ghee."
},
{
    "id":"3",
    "name":"Egg Dosa",
    "price" :"Price :₹40",
    "image": process.env.PUBLIC_URL + "/assests/Dosa/1e.png",
    "description": "Crispy, classic street-style dosa layered with a cracked egg, finely chopped onions, and a sprinkle of spicy podi masala."
},
{
    "id":"4",
    "name":"Green gram  Dosa\n(Pesarattu)",
    "price" :"Price :₹55",
    "image": process.env.PUBLIC_URL + "/assests/Dosa/3g.png",
    "description": "Healthy and crisp whole green gram crepe, traditionally served with allam (ginger) chutney."
},{
    "id":"5",
    "name":"Finger Millet Dosa\n(Ragi Dosa)",
    "price" :"Price :₹55",
    "image": process.env.PUBLIC_URL + "/assests/Dosa/2f.png",
    "description": "A highly nutritious, crispy crepe made from fiber-rich ragi batter, served hot with fresh coconut chutney."
}]